/**
 * Qué empresa de la cuenta se está mirando ahora mismo.
 *
 * Vive en `localStorage` por el mismo motivo que la selección del contador
 * (`lib/accountantAccess.ts`): es una preferencia de esta pestaña, no un permiso. El valor que se
 * guarda aquí **no concede acceso a nada**. Quien decide es `has_tenant_access` en la base, y
 * `resolveTenantId` comprueba contra el servidor que la empresa elegida sea de verdad de la cuenta
 * antes de usarla; si no lo es, la olvida y se cae a la principal.
 *
 * Sin esa comprobación bastaría con escribir el uuid de otra empresa en el almacenamiento del
 * navegador para pedir sus datos.
 */

export const EMPRESA_ACTIVA_KEY = 'contabird.empresa_activa';

const ES_UUID = /^[0-9a-f-]{36}$/i;

export function getEmpresaActivaId(): string | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(EMPRESA_ACTIVA_KEY);
  return value && ES_UUID.test(value) ? value : null;
}

export function setEmpresaActivaId(empresaId: string) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(EMPRESA_ACTIVA_KEY, empresaId);
}

export function clearEmpresaActiva() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(EMPRESA_ACTIVA_KEY);
}
